import React from "react";
import CatalogBotsContainer from "../../BotsContainer";

const CategoryAllBotsView = (props) => {
	const { bots, category, userDomain } = props;

	return (
		<div className="container-fluid">
			<div className="row">
				<div className="flex flex-col">
					<div className="flex justify-center items-center mb-4">
						<h3
							className={`title mb-0 order-0 ms-44 ${userDomain}_font`}
							style={{
								color: "#4A4A4A",
								fontWeight: 600,
							}}
						>
							{category}
						</h3>
					</div>

					<div>
						<CatalogBotsContainer
							bots={bots}
							botHolderStyle={{
								marginBottom: "10px",
								borderRadius: "10px",
								boxShadow: "rgba(0, 0, 0, 0.2) 0px 0px 6px ",
							}}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CategoryAllBotsView;
